import { createFileRoute } from '@tanstack/react-router'
import { StaffLifeEvents } from '../../../../components/StaffLifeEvents'

export const Route = createFileRoute('/desa/$slug/dashboard/life-events')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffLifeEvents desaId={desaId} />
  },
})
